import { render, staticRenderFns } from "./WaitModal.vue?vue&type=template&id=c285b4f2&"
import script from "./WaitModal.vue?vue&type=script&lang=js&"
export * from "./WaitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports